var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.catalog.begin_year)?_c('p',{staticClass:"exhibitionDates"},[_vm._v("\n  "+_vm._s(_vm.$t('pages.results.catalogDates'))+" :\n  "+_vm._s(_vm.catalog.begin_day !== 0 ? _vm.catalog.begin_day : '')+" "+_vm._s(_vm.getMonth(_vm.catalog.begin_month))+" "+_vm._s(_vm.catalog.begin_year)+"\n  -\n  "+_vm._s(_vm.catalog.end_day !== 0 ? _vm.catalog.end_day : '')+" "+_vm._s(_vm.getMonth(_vm.catalog.end_month))+" "+_vm._s(_vm.catalog.end_year)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d003d90","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalog/CatalogDates.vue
// module id = 643
// module chunks = 1